export default {
  QUEST_ONBOARDING_QUESTID: 'c-greta-onboarding',
  USER_ID: 'u-cd9ba528-d60b-4cd3-8370-aefeac718dd7',
  APIKEY: 'k-ad08c316-7c33-4eef-bde4-7647da07a2fb',
  TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1LWNkOWJhNTI4LWQ2MGItNGNkMy04MzcwLWFlZmVhYzcxOGRkNyIsImlhdCI6MTc1MTU1Mjc1OCwiZXhwIjoxNzU0MTQ0NzU4fQ.9mm0XSPOUdcHa9wqd2b-bru5iwxNwhzuS5mxKyIfYxY',
  ENTITYID: 'e-d9eb7542-02ac-46f1-a31d-1203810046c4',
  PRIMARY_COLOR: '#2563eb' // Extracted from your primary-600 color
};